import React from 'react';
export function UrgencyBar() {
  return <div className="w-full bg-brand-deep px-4 py-2.5 text-center" data-id="element-163" data-mp="m2ozmg4rxyjl">
      <p className="font-display text-[11px] font-extrabold uppercase leading-tight tracking-wider text-white sm:text-sm" data-id="element-164" data-mp="3cw7o0ld7hia0">
        <span aria-hidden="true" data-id="element-165" data-mp="37uibt2e8yykc">🔴</span> Oferta de lanzamiento: 75% de
        descuento disponible solo por hoy.
      </p>
    </div>;
}